import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import { Box } from '@mui/material';

import LoadingProgress from '@components/LoadingProgress';

import { useInitWebcamDevices } from '@core/devices/components/DevicesTest/WebcamTest/hooks';
import CamerasSelection from './CamerasSelection';
import { useConferenceState } from '@hooks/conferenceContext';

import { useStyles } from './styles';
import HelperBox from '../HelperBox';

const WebcamTest = () => {
  const classes = useStyles();
  const { initializing, videoRef, devices, startCameraStream } =
    useInitWebcamDevices();
  const { activeCameraDeviceId, setActiveCameraDeviceId } =
    useConferenceState();
  const { t: translate } = useTranslation();
  const handleDeviceChange = async (deviceId: string) => {
    setActiveCameraDeviceId(deviceId);
    await startCameraStream(deviceId);
  };

  if (initializing) {
    return <LoadingProgress />;
  }

  return (
    <Box>
      <Box sx={classes.root}>
        <video ref={videoRef} autoPlay playsInline />
        {!isMobileOnly && (
          <CamerasSelection
            devices={devices}
            activeDeviceId={activeCameraDeviceId}
            onDeviceChange={handleDeviceChange}
            sx={classes.selection}
            menuProps={{
              PaperProps: {
                sx: classes.paper,
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
              },
            }}
          />
        )}
      </Box>
      <HelperBox
        title={translate('devicesTest.webcamTest.helper.title')}
        text={translate('devicesTest.webcamTest.helper.text')}
      />
    </Box>
  );
};

export default WebcamTest;
